var Product = function(key)
{
	/**
	 * The key of this product, can be used to find the right object 
	 */
	this.key = key;
	
	/**
	 * The calculater for this object, holds some values for the fields 
	 */
	this.calculator = new Calculator(this);
	this.formatter = new Formatter(this);
	
	/**
	 * All the fields of this object 
	 */
	this.fields = {};
	
	/**
	 * The stack which is currently running 
	 */
	this.activeStack;
	
	/**
	 * Start function when the Product is created 
	 */
	this.init = function(options)
	{
		// Create all the fields and send along its options
		for(field in options)
		{
			console.log('Product: create field: ' + field);
			this.fields[field] = new Field(this, field, options[field]);
		}
		
		// Create all the fields and send along its options
		for(field in options)
		{
			this.fields[field].init();
		}
	}
}